import { useLocalObservable } from 'mobx-react-lite';
import { View } from 'react-big-calendar';

import { ONE_HOUR, ONE_MINUTE, ONE_SECOND } from '@gem/services/date-service';

import { IEventCalendar } from '../Content.types';

export interface IScrollToFirstEventPresenter {
  setScrollAnchor(anchor: Date): void;
  setCalendarKey(key: string): void;
  calculateFirstEvent(
    currentRange: { start: Date; end: Date },
    events: IEventCalendar[],
    currentDate: Date,
    currentView: View
  ): void;
  scrollAnchor: Date | undefined;
  calendarKey: string;
}

export const useScrollToFirstEventPresenter = (): IScrollToFirstEventPresenter => {
  const presenter = useLocalObservable<IScrollToFirstEventPresenter>(() => ({
    scrollAnchor: undefined,
    calendarKey: 'init',

    setScrollAnchor(anchor: Date): void {
      presenter.scrollAnchor = anchor;
    },

    setCalendarKey(key: string): void {
      presenter.calendarKey = key;
    },

    calculateFirstEvent(currentRange, events, currentDate, currentView): void {
      const timeOfDayMs = (d: Date): number =>
        d.getHours() * ONE_HOUR +
        d.getMinutes() * ONE_MINUTE +
        d.getSeconds() * ONE_SECOND +
        d.getMilliseconds();

      const start = currentRange.start;
      const end = currentRange.end;
      const list = events
        .filter((event) => event.start < end && event.end > start && !event.allDay)
        .sort((a, b) => timeOfDayMs(a.start) - timeOfDayMs(b.start));
      const first = list[0]?.start || null;

      const anchor = new Date(currentDate);
      if (first) {
        anchor.setHours(first.getHours(), first.getMinutes(), 0, 0);
      } else {
        anchor.setHours(9, 0, 0, 0);
      }
      presenter.setScrollAnchor(anchor);
      // ремонтнём календарь, чтобы он применил новый scrollToTime
      presenter.setCalendarKey(`${currentView}-${anchor.getHours()}`);
    },
  }));

  return presenter;
};
